'use client';
import { GoogleTagManager } from '@next/third-parties/google';
import { isProduction } from '@treyd-io/core/constants/api';
import { toNumber, toString } from 'lodash';
import { useSession } from 'next-auth/react';

interface GoogleTagManagerProviderProps {
  gtmId: string;
  dataLayer: {
    user: number;
    user_email: string;
  };
  isTreydUser?: boolean;
}

const GoogleTagManagerComponent = ({
  gtmId,
  dataLayer,
  isTreydUser,
}: GoogleTagManagerProviderProps) => {
  return (
    isProduction &&
    !isTreydUser && <GoogleTagManager gtmId={gtmId} dataLayer={dataLayer} />
  );
};

export const GoogleTagManagerProvider = () => {
  const { data, status } = useSession();

  const args = {
    gtmId: 'GTM-PJZ4CZ6',
    dataLayer: {
      user: toNumber(data?.user?.id),
      user_email: toString(data?.user?.email),
    },
  };

  const isTreydUser = data?.user?.is_treyd_user;

  if (status === 'loading') return;

  return (
    <GoogleTagManagerComponent
      gtmId={args.gtmId}
      dataLayer={args.dataLayer}
      isTreydUser={isTreydUser}
    />
  );
};
